/**
 * Profit IQ design tokens.
 *
 * The values mirror `src/screens/ProfitPulse/theme.ts` in the order-manager-lite
 * app so the two clients read the same, resolved here against literals because
 * the partner portal has no equivalent palette module.
 */
export const colors = {
  text: '#1D1B20',
  tint: '#FF8A00',

  background: '#F6F6F9',
  foreground: '#1D1B20',

  card: '#FFFFFF',
  cardForeground: '#1D1B20',

  primary: '#FF8A00',
  primaryForeground: '#FFFFFF',

  secondary: '#F2F2F2',
  secondaryForeground: '#1D1B20',

  muted: '#F2F2F2',
  mutedForeground: '#49454F',

  accent: '#FFF3E5',
  accentForeground: '#B35F00',

  destructive: '#E21508',
  destructiveForeground: '#FFFFFF',

  border: '#E0E0E0',
  input: '#E0E0E0',

  headerBg: '#3C4350',

  success: '#00984F',
  warning: '#B26A00',

  successSurface: '#E6F5EE',
  successSurfaceForeground: '#00693A',
  warningSurface: '#FFF6E5',
  warningSurfaceForeground: '#8A5200',
  destructiveSurface: '#FDEDEC',
  destructiveSurfaceForeground: '#A5100A',

  faint: '#8B8B8B',
};

/** Font sizes, aligned with the mobile type scale. */
export const typography = {
  caption: 12,
  small: 14,
  body: 14,
  emphasis: 16,
  subtitle: 16,
  heading: 18,
  title: 22,
  display: 24,
  stat: 28,
  hero: 45,
};

export const BASE_PATH = '/profit-iq';

/** The seven in-page tabs, in the order the mobile app shows them. */
export const TABS = [
  { key: 'overview', path: `${BASE_PATH}/overview`, label: 'Overview' },
  { key: 'menu', path: `${BASE_PATH}/menu-items`, label: 'Menu Items' },
  { key: 'categories', path: `${BASE_PATH}/categories`, label: 'Categories' },
  { key: 'channels', path: `${BASE_PATH}/channels`, label: 'Channels' },
  { key: 'costs', path: `${BASE_PATH}/my-costs`, label: 'My Costs' },
  { key: 'settings', path: `${BASE_PATH}/settings`, label: 'Settings' },
  { key: 'insights', path: `${BASE_PATH}/insights`, label: 'Insights' },
];

export const IMPORT_PATH = `${BASE_PATH}/import`;

/** Support line shown on the locked screen, matching the chargeback upgrade copy. */
export const SUPPORT_PHONE = '855 500 1070';

/** Shared card styling for the section. */
export const cardSx = {
  borderRadius: 3,
  border: `1px solid ${colors.border}`,
  backgroundColor: colors.card,
};
